export const setUserHasSeenModal = () => ({
  type: 'USER_HAS_SEEN_MODAL',
});

export const setUserHasNotSeenModal = () => ({
  type: 'USER_HAS_NOT_SEEN_MODAL',
});



// WEBPACK FOOTER //
// ./src/actions/app.js